import { UserRoleEnum } from '@authority-labs/enums';

/**
 * Rank of a role for "manage only the same or lower" rules - lower is more
 * senior. super-admin always ranks first. sortOrder is otherwise a display
 * column that defaults to 0, so a role without a positive sortOrder ranks
 * last rather than above everyone.
 */
export function roleRank(
  role: { key?: string; sortOrder?: number } | null | undefined
): number {
  if (!role) {
    return Number.POSITIVE_INFINITY;
  }
  if (role.key === UserRoleEnum.SuperAdmin) {
    return 0;
  }
  return role.sortOrder > 0 ? role.sortOrder : Number.POSITIVE_INFINITY;
}
